import { render, staticRenderFns } from "./ModalReimportContacts.vue?vue&type=template&id=8c19d598"
import script from "./ModalReimportContacts.vue?vue&type=script&lang=js"
export * from "./ModalReimportContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c19d598')) {
      api.createRecord('8c19d598', component.options)
    } else {
      api.reload('8c19d598', component.options)
    }
    module.hot.accept("./ModalReimportContacts.vue?vue&type=template&id=8c19d598", function () {
      api.rerender('8c19d598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/personalization/ModalReimportContacts.vue"
export default component.exports